import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from "@/views/Home"
import List from "@/views/List"
import Detail from "@/views/Detail"
import Qwss from "@/views/Qwss"

Vue.use(VueRouter)

const routes = [
    {path: '/', component: Home, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统'}},
    {path: '/sygp', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-所有挂牌'}},
    {path: '/zzgg', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-正在公告'}},
    {path: '/zzgp', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-正在挂牌'}},
    {path: '/zzzs', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-正在资审'}},
    {path: '/jjjg', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-竞价结果'}},
    {path: '/jggs', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-结果公示'}},
    {path: '/gzgg', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-更正公告'}},
    {path: '/tzgg', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-通知公告'}},
    {path: '/zlxz', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-资料下载'}},
    {path: '/detail', component: Detail, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统'}},
    {path: '/qwss', component: Qwss, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-全文搜索'}},
    {path: '/qtgg', component: List, meta: {title: '汕尾市土地与矿业权和耕地指标交易系统-其它公告'}},
];

const router = new VueRouter({
    mode: 'history',
    base: '/gtzyjygcxx/',
    routes
});

router.afterEach(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});

export default router
